import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DOC_GENERATION_FEATURE_CODE } from '../features/plans/models/entitlement.model';
import { PlanFeatureService } from '../features/plans/services/plan-feature.service';

/**
 * Bloquea /generate y /generate/mis-resumenes cuando el plan efectivo de la cuenta
 * no tiene la feature `doc_generation`; redirige a /home.
 */
@Injectable({ providedIn: 'root' })
export class DocGenerationFeatureGuard implements CanMatch, CanActivate {
  constructor(
    private readonly planFeatures: PlanFeatureService,
    private readonly router: Router
  ) {}

  private check(): Observable<boolean | UrlTree> {
    return this.planFeatures.hasFeature(DOC_GENERATION_FEATURE_CODE).pipe(
      take(1),
      map((hasFeature) => (hasFeature ? true : this.router.createUrlTree(['/home'])))
    );
  }

  canMatch(): Observable<boolean | UrlTree> {
    return this.check();
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.check();
  }
}
